import type { TypePolicy } from '@apollo/client';
import { cursorPaginationFieldPolicy } from '../../../../utils/policies/cursorPaginationFieldPolicy';

const userGroupRelationshipFields = () => ({
  directMemberships: cursorPaginationFieldPolicy([
    'page',
    ['first'],
    'membershipFilter',
  ]),
  members: cursorPaginationFieldPolicy([
    'page',
    ['first'],
    'membershipFilter',
    ['query'],
  ]),
});

const accountUserGroupsFieldPolicy = () =>
  cursorPaginationFieldPolicy([
    'page',
    ['first'],
    'filter',
    ['name'],
    'order',
    ['field', 'direction'],
  ]);

export const typePolicies: Record<string, TypePolicy> = {
  Account: {
    fields: {
      accountUserGroups: accountUserGroupsFieldPolicy(),
      userGroups: accountUserGroupsFieldPolicy(),
    },
  },
  AccountUserGroup: {
    fields: userGroupRelationshipFields(),
  },
  UserGroup: {
    fields: userGroupRelationshipFields(),
    keyFields: ({ id }) => `UserGroup:${id}`,
  },
};
